import { SVGProps } from "react";

export const Calendar2SVG = ({
  color = "#25324B",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
		{...props}
  >
    <g>
      <path
        d="M14.0683 10.2285C14.1265 10.2866 14.1727 10.3556 14.2042 10.4315C14.2357 10.5074 14.2519 10.5888 14.2519 10.671C14.2519 10.7532 14.2357 10.8346 14.2042 10.9106C14.1727 10.9865 14.1265 11.0555 14.0683 11.1135L10.3183 14.8635C10.2602 14.9217 10.1913 14.9679 10.1153 14.9994C10.0394 15.0309 9.958 15.0472 9.87579 15.0472C9.79358 15.0472 9.71218 15.0309 9.63625 14.9994C9.56032 14.9679 9.49135 14.9217 9.43329 14.8635L7.55829 12.9885C7.50018 12.9304 7.45408 12.8614 7.42264 12.7855C7.39119 12.7096 7.375 12.6282 7.375 12.546C7.375 12.4639 7.39119 12.3825 7.42264 12.3066C7.45408 12.2306 7.50018 12.1616 7.55829 12.1035C7.67565 11.9862 7.83482 11.9202 8.00079 11.9202C8.08297 11.9202 8.16435 11.9364 8.24027 11.9679C8.31619 11.9993 8.38518 12.0454 8.44329 12.1035L9.87579 13.5373L13.1833 10.2285C13.2413 10.1703 13.3103 10.1242 13.3862 10.0926C13.4622 10.0611 13.5436 10.0449 13.6258 10.0449C13.708 10.0449 13.7894 10.0611 13.8653 10.0926C13.9413 10.1242 14.0102 10.1703 14.0683 10.2285Z"
        fill="#4640DE"
      />
      <path
        d="M4.875 0.0461426C5.04076 0.0461426 5.19973 0.111991 5.31694 0.229201C5.43415 0.346411 5.5 0.505382 5.5 0.671143V1.29614H15.5V0.671143C15.5 0.505382 15.5658 0.346411 15.6831 0.229201C15.8003 0.111991 15.9592 0.0461426 16.125 0.0461426C16.2908 0.0461426 16.4497 0.111991 16.5669 0.229201C16.6842 0.346411 16.75 0.505382 16.75 0.671143V1.29614H18C18.663 1.29614 19.2989 1.55953 19.7678 2.02838C20.2366 2.49722 20.5 3.1331 20.5 3.79614V17.5461C20.5 18.2092 20.2366 18.8451 19.7678 19.3139C19.2989 19.7827 18.663 20.0461 18 20.0461H3C2.33696 20.0461 1.70107 19.7827 1.23223 19.3139C0.763392 18.8451 0.5 18.2092 0.5 17.5461V3.79614C0.5 3.1331 0.763392 2.49722 1.23223 2.02838C1.70107 1.55953 2.33696 1.29614 3 1.29614H4.25V0.671143C4.25 0.505382 4.31585 0.346411 4.43306 0.229201C4.55027 0.111991 4.70924 0.0461426 4.875 0.0461426V0.0461426ZM3 2.54614C2.66848 2.54614 2.35054 2.67784 2.11612 2.91226C1.8817 3.14668 1.75 3.46462 1.75 3.79614V17.5461C1.75 17.8777 1.8817 18.1956 2.11612 18.43C2.35054 18.6644 2.66848 18.7961 3 18.7961H18C18.3315 18.7961 18.6495 18.6644 18.8839 18.43C19.1183 18.1956 19.25 17.8777 19.25 17.5461V3.79614C19.25 3.46462 19.1183 3.14668 18.8839 2.91226C18.6495 2.67784 18.3315 2.54614 18 2.54614H3Z"
        fill="#4640DE"
      />
      <path
        d="M3.625 5.04614C3.625 4.88038 3.69085 4.72141 3.80806 4.6042C3.92527 4.48699 4.08424 4.42114 4.25 4.42114H16.75C16.9158 4.42114 17.0747 4.48699 17.1919 4.6042C17.3092 4.72141 17.375 4.88038 17.375 5.04614V6.29614C17.375 6.4619 17.3092 6.62087 17.1919 6.73808C17.0747 6.85529 16.9158 6.92114 16.75 6.92114H4.25C4.08424 6.92114 3.92527 6.85529 3.80806 6.73808C3.69085 6.62087 3.625 6.4619 3.625 6.29614V5.04614Z"
        fill="#4640DE"
      />
    </g>
    <defs>
      <clipPath id="clip0_31361_3745">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.5 0.0461426)"
        />
      </clipPath>
    </defs>
  </svg>
);
